
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogModule } from '@angular/cdk/dialog';
import { ViewToggleComponent } from './view-toggle-popout/view-toggle.component';
import { PopoutButtonComponent } from '@jeppesen-foreflight/jmkw-toolkit';

@Component({
  standalone: true,
  imports: [PopoutButtonComponent, DialogModule],
  templateUrl: './view-toggle-button.component.html',
  styleUrls: ['./view-toggle-button.component.scss'],

  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewToggleButtonComponent {
  componentRef = ViewToggleComponent;
  iconName = 'icon-eye';
}
